import { useCallback, useState } from 'react'
import { useDrawer } from '@/core/context/DrawerContext'
import { Row, SortingState, Table } from '@atbay/cyber-components'
import { Analytics } from '@/core/services/mixpanel'
import { getHighestSeverity } from '../utils'
import { getTableRowContext } from '@/ui/utils/tableUtils'

interface UseAssetsTableProps {
    assets: TAsset[]
    origin?: string
}

export const useAssetsTable = ({
    origin = 'assets_table',
}: UseAssetsTableProps) => {
    const [sorting, setSorting] = useState<SortingState>([])
    const { setDrawerState, drawerState } = useDrawer()

    const {
        isDrawerOpen,
        contentProps: { assets: sortedAssets, index: sortedIndex },
    } = drawerState

    const handleRowClick = useCallback(
        (row: Row<TAsset>, table: Table<TAsset>) => {
            const { sortedIndex, items: sortedAssets } = getTableRowContext(
                row,
                table
            )
            const asset = row.original
            const highestSeverity = getHighestSeverity(asset.issues)

            setDrawerState((prevState) => ({
                ...prevState,
                isDrawerOpen: true,
                drawerContentType: 'assetDetails',
                contentProps: {
                    assets: sortedAssets,
                    index: sortedIndex,
                },
            }))

            Analytics.event('SEM::user_clicks_at_asset', {
                origin,
                assetId: asset.id,
                assetType: asset.asset_type,
                severity: highestSeverity,
            })
        },
        [setDrawerState, origin]
    )

    const activeAssetId = isDrawerOpen
        ? sortedAssets?.[sortedIndex]?.id
        : undefined

    return {
        sorting,
        setSorting,
        handleRowClick,
        activeAssetId,
    }
}
